import axios from 'axios';
import router from '@/routes';

const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:4000/api';
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');
export const fileUrl = (relativePath) => {
  if (!relativePath) return null;
  const token = localStorage.getItem('tr_token');
  return `${API_ORIGIN}${relativePath}${token ? `?token=${token}` : ''}`;
};

const http = axios.create({
  baseURL: API_BASE_URL,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('tr_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('tr_token');
      localStorage.removeItem('tr_user');
      if (router.currentRoute.value.meta.layout !== 'guest') {
        router.push('/authentication/sign-in');
      }
    }
    return Promise.reject(error);
  }
);

export default http;
